import { render, staticRenderFns } from "./ProductAlternatives.vue?vue&type=template&id=5d7de8df&scoped=true&"
import script from "./ProductAlternatives.vue?vue&type=script&lang=js&"
export * from "./ProductAlternatives.vue?vue&type=script&lang=js&"
import style0 from "./ProductAlternatives.vue?vue&type=style&index=0&id=5d7de8df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7de8df",
  null
  
)

export default component.exports